module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("David L. Wanker, captain, United Systems Space Forces, stood at an observation window inside the orbital graving dock; from this vantage point he beheld the vast and—to him—obscene bulk of the U.S.S. "), _c('i', [_vm._v("Repulse ")]), _vm._v("as it hung in its bottomless repair bay.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was something in its contours—perhaps in its bulging sensor pods or protruding weapon housings—that made it the concretization of an enormous dirty joke. The "), _c('i', [_vm._v("Repulse ")]), _vm._v("was of an odd design: ungainly, ill-proportioned, and almost comically obsolete. Why the Forces had not decommissioned her long ago was anybody’s guess, but one thing was certain: recent United Systems defense budget cuts assured that the "), _c('i', [_vm._v("Repulse ")]), _vm._v("would continue to be a ship of the line for some time to come. Replacing her was an enormously expensive proposition (to continue the dirty joke metaphor).")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Captain Wanker viewed it all with dismay and a sense of foreboding, his freckled pug nose twitching. He looked younger than his thirty-eight years; in fact, his face was still boyish, and a still-boyish part of him was thrilled with the prospect of a new command. He had bright blue eyes and a receding chin and practically no beard at all. He was lucky to need a shave once a week. He had always worried about this lack of facial hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He considered it a shameful genetic defect.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Speaking of boyish thrills—yes, those forward sensor pods, their apexes stenciled in warning red, did indeed resemble voluptuous breasts. From the distended line of the keel, a huge particle beam accelerator hung like the professional equipment of an old stallion at stud, ready for service. At various places along the hull, orifices gaped and buttocklike features protruded. But the whole effect was more tawdry than erotic.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("David Wanker sighed. And now he was captain of this space-going bawdyhouse. The prospect of a new command promptly lost its glamour.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He looked down through the repair bay and saw five hundred kilometers to the surface of the planet below. Epsilon Indi II was a world almost without weather, no clouds to obscure its endless wastelands, which made it the perfect space base. “Ship’s liberty” was meaningless here. There was nothing for an able spaceman to do, aside from having an ersatz sexual encounter in one of the base’s few simsex pods. The wait for the use of these ran to days, sometimes weeks. Otherwise, there was nowhere to go and nothing to do; no joy houses, no flesh pots, no diversions of any kind. No drunken spacemen ear-lye in the morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("No cheap thrills, barring one’s classification of “mud-humping” as a thrill. He had heard about it. The planet’s surface was peculiar. Near the Space Forces base lay great shallow lakes of mud. Bathing in the mud was, according to scuttlebutt, fun and somewhat medicinal—good for a certain few ailments, especially “space crud,” a form of psoriasis induced by long exposure to dry, recycled air."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There were other mudholes, however, that offered even better recreational opportunities. The mixture in these shallow and completely safe quicksand pits was of such viscosity, texture, and slipperiness as to approximate … to put it bluntly, the mud sucked; hence, if a spaceman was aroused enough and in a sufficiently advanced state of carnal deprivation (there were simply not enough female personnel to go around, and some of them were—well, never mind), why, he could, trouserless, prostrate himself and let nature take its course.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Not that David Wanker would ever stoop to such a base practice. That was for your common swab. David Wanker was an officer and a gentleman. He had just spent three weeks down there and hadn’t gone near the simsex pods, much less the mudholes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Again he took in the ugliness of the "), _c('i', [_vm._v("Repulse. ")]), _vm._v("Its hull bore the scars of micrometeorite impacts and the constant abrasion of the interstellar gas and dust that any starship encounters as it streaks through space at trans-relativistic speeds. The composite material of the hull was scratched and pitted. The repair crew was busy sanding down the worst of it but the task was endless and hopeless. A special detail was hard at work on the prow of the ship, repairing damage done in a recent mishap: a collision with a tanker. Unfortunately, mishaps were not unusual for the "), _c('i', [_vm._v("Repulse.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker turned away from the wide view window and almost bumped into a burly chief warrant officer in a stained work jumper.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The warrant officer, some years Wanker’s senior, saluted casually and said, “Pardon me, sir. Can I help you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker returned a crisp salute. Then his narrow shoulders slumped forlornly. “Only the Creator of All Things in Her infinite mercy can help me now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The chief squinted one pale eye. “Sir?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m the new captain of that”—Wanker gestured vaguely out the window—”sorry-looking tub.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Understanding dawned, and the chief nodded commiseration. “Best of luck to you, sir. She’s a jinx, that one is. Never saw a ship that had so many strange things happen to her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, like what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The chief scratched his graying head. “Well, sir, for instance, take the last time she was in here for repairs. Total life-support systems failure. But it wasn’t just your garden-variety failure. Somehow—sir, don’t ask me how—the ship’s waste containment system got hooked up with the air circulation network. Some chowderhead connected two pipes that shouldn’t have been connected, and liquefied biomass got into the nitrogen/helium compressors.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker was appalled. “Good gracious.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That wasn’t the worst of it, sir. The compressors kept working and pumped atomized sludge into the air blowers. You wouldn’t have believed the mess when the biomass hit the rotoimpellers.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker’s gray-green eyes widened in alarm. “No!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes! Sir. Sludge blowing out every vent in the vessel. Everyone got a brown shower.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker looked suddenly queasy. “The very thought… ”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The chief shook his graying head. “It wasn’t a pretty sight, sir, that I can tell you.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Nor a pretty smell, I’ll wager!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, sir. And then there was the time she collided with Admiral Dickover’s flagship in a docking maneuver.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I remember that. Dickover was fit to be tied.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The chief nodded. “Took months to repair both ships. Then there was the time the engineering crew pulled all the control dampers out of the main dark-matter reactor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker was stunned. “Why did they do that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It stalled and they thought they could Chernobyl it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But that’s dangerous!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Er, yes, sir. It is.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What happened?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, the reactor went hypercritical and they had to do an explosive decouple and drop the whole reactor pod. Only trouble was, at the time they were in an unstable orbit over an inhabited planet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re joking!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Wish I was, sir. The pod entered the atmosphere as the reactor was undergoing a hypercritical blowout.” Again the chief shook his head in infinite regret. “It was a mess below.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I should say so, all that radioactive debris scattered everywhere. What happened?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, sir, fortunately the reactor impacted in an area of relatively low population density. They managed to evacuate … and, well, sir, the upshot was that they had to write off a small continent. Could have been worse.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Dear heavens. Why didn’t I hear about this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hushed up, sir. I got the story from an ensign on the investigating team. Also, I supervised the installation of the new reactor. Sir, there wasn’t an old reactor to take out. Don’t blame you if you don’t believe, me, captain.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll take your word for it, chief.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And then there was the time—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker held up a hand. “Chief, wait, please. I’m nervous enough as it is. Thanks for your help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sorry, sir. By the way, sir, may I ask where your authorization pass is?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker looked down the front of his threadbare uniform. The plastic badge he had pinned on at the checkpoint was missing. He was about to hazard an explanation when he looked up and found a mug shot of himself dangling in front of his face. The picture was on his authorization badge.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Looking for this, Captain Wanker?” The chief’s eyes twinkled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s Vahn-ker.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Beg your pardon, sir?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s how you pronounce my name. Vahn-ker. It’s German.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh. Sorry, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Never mind.” Wanker took the badge. “Thank you. Damned thing must have come undone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wanker opened the pin, promptly pricked his thumb, and yelped.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Damn it all, here we are in the middle of the twenty-second century and they can’t find a better way to stick a badge on a man than jabbing a pin through him!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Let me help you with that, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With the chief’s assistance, Wanker was re-pinned and properly authorized to be present in the graving dock.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Chastened, Wanker said, “Thank you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If there’s anything else, sir?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That will be all, Chief.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, sir. And good luck to you, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll bloody well need it,” Wanker muttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The chief went out through the observation bay’s only hatch, leaving David Wanker to take one last look out the window before heading toward the gangway tube. Just then he noticed something.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The name of the ship was painted on a forward section of the hull. Some wag had sloppily interpolated two more letters after the penultimate one.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("R E P U L S iv E")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How appropriate,” Wanker murmured. “How very appropriate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He picked up his spacebag. It was as heavy as the sense of impending doom that now settled on him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Inconsolably glum, he left the observation bay.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lieutenant (jg) Darvona Roundheels, blond and pretty but perhaps a tad plump, sat at her communications console, idly blowing on her prosthetic fingernails. She had just painted them a pulsing shade of fluorescent pink. Mandarin fingernails, the wickedly curving sort that came in lengths up to ten centimeters long, were the rage this year but regulations forbade such frippery. Darvona had to content herself with nails only two centimeters long, but she made up for it by painting them a new color every few days, or applying floral decals, or gilding the tips.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She was alone on the bridge. The "), _c('i', [_vm._v("Repulse ")]), _vm._v("was all but deserted, manned only by a skeleton crew.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Darvona resented being assigned to duty, though she had to admit that she had screwed up badly during the docking maneuver. She had been daydreaming, and—well it was an honest mistake. Anyone can make a mistake, she assured herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Still, it was rotten to draw duty when ninety percent of the crew had liberty. Not that there was anything to do dirtside, except maybe hang out in the rec hall and play games. Or find some new enlisted man to have lots of sex with. Or, better yet, find two or three enlisted men to have lots of sex with. Or … even better than that—")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her reverie was interrupted by the whoosh of the bridge’s access tube as it dropped an ensign to the deck. It was Ensign Svensen, a navigation systems engineer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Svensen stepped out from under the end of the transparent tube, gave Darvona a cross between a smirk and a snarl, then strode to his control console.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hi, Sven,” Darvona called, giving him a fetching smile. Svensen was cute but obviously didn’t like women, because she had never fetched him with one of her smiles, not even her best man-melter. “What’s new?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Word is the new captain will be here today.” Sven began punching buttons and flipping switches.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I hope we have better luck with this one. We don’t do well with captains.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh?” Svensen said coolly. “Now, what would make you say that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What would make me say it? We’ve had no less than three in the last standard year. And they’ve all—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Four.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Four? Has it been that many? Oh, wait, you must be counting the one that got mangled when the shuttle got crushed between the ship and the tanker.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes. Captain Moore was his name, I believe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Poor Dinty. I don’t count him, ‘cause he was in command only two days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He was captain of this ship. He counts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, if you insist. Four.” Darvona ruminated a moment. “Actually, when you think of it, it’s all been a result of bad luck more than anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Svensen grunted, then gave a mirthless laugh as he continued to work.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What’s with you?” Darvona wanted to know.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“ ‘Bad luck.’ You must be kidding.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, I really don’t think it was our fault. The crew’s fault, I mean.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Aside from the captain that got reduced to puree, we had one suicide, one dismissed in disgrace, and one committed to psych rehab.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Poor Captain Chang. I really liked her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I hear she’s doing well in occupational therapy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And I "), _c('i', [_vm._v("adored ")]), _vm._v("Captain Suomi,” Darvona said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Mr. Rhodes gave a nice eulogy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, it was.” Darvona shook her head sadly. “Okay, you’re right. I guess we do have our problems. We haven’t been doing so great lately.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s one hell of an understatement. You don’t get the lowest rating in the Space Forces by being anything close to ‘great.’ And don’t forget the countless reprimands we’ve been slapped with.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who can forget?” Darvona wailed. “I haven’t had a promotion in years.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We’ve all been passed over any number of times, so don’t feel singled out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Somehow, I do. I always seemed to get blamed!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Quit squawking. We’ve all goofed on one occasion or another. We’re all to blame.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I hope this new captain can help us get back on our feet. By the way, what’s his name again?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Wanker.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Darvona scowled. “Wanker?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You took the communication. Didn’t you read it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Guess I did, but it didn’t register.” Darvona pouted. “Great. Now we have a Wanker for a captain.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sven shrugged, continuing to snap switches. “He ought to fit right in.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23ab6361","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 75
// module chunks = 0